/**
 * Australia date format validator. A temporary solution
 * TODO: Bring in limited locale moment.js module
 * @param {String} value
 */
const aussieDateValidator = function(value) {
  var reg = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/g
  return reg.test(value) || !value || value.length === 0
}

export { aussieDateValidator }
